"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookie = void 0;
function getCookie(name) {
    var _a;
    try {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return (_a = parts.pop()) === null || _a === void 0 ? void 0 : _a.split(';').shift();
        }
        return null;
    }
    catch (e) {
        return null;
    }
}
exports.getCookie = getCookie;
